// extracted by mini-css-extract-plugin
module.exports = {"BuildIcon_active":"styles_BuildIcon_active__rqnyR","BuildIcon_disabled":"styles_BuildIcon_disabled__UXgQC","BuildIcon_selected":"styles_BuildIcon_selected___K6rC"};